
// PM零售负责人对话框配置
export const pmRetailDialogConfig = {
  title: "PM零售负责人提成",
  readOnlyFields: [
    { label: "一级部门", prop: "dept" },
    { label: "岗位", prop: "position" },
    { label: "职级", prop: "rank" },
    { label: "姓名", prop: "name" },
    { label: "工号", prop: "empno" },
    { label: "渠道", prop: "channel" },
    { label: "考核类型", prop: "type" },
    { label: "目标销量", prop: "volume" },
    { label: "岗位提成率（%）", prop: "royaltyrate" },
    { label: "目标净毛利率（%）", prop: "ngm" },
  ],
  editableFields: [
    {
      label: "提成月份",
      prop: "month",
      placeholder: "请输入提成月份",
      required: true,
      unit:'月'
    },
    {
      label: "实际完成",
      prop: "realfinish",
      placeholder: "请输入实际完成销量",
      required: true,
    },
    {
      label: "KPI得分",
      prop: "kpiscore",
      placeholder: "请输入KPI得分",
      required: true,
    },
    {
      label: "实际毛利率",
      prop: "realngm",
      placeholder: "请输入实际毛利率",
      required: true,
      unit:'%'

    },
    {
      label: "调节系数",
      prop: "adjust",
      placeholder: "请输入调节系数",
      required: true,
    },
    {
      label: "补发",
      prop: "reissue",
      placeholder: "请输入补发金额",
      required: true,
      unit:'元'

    },
    {
      label: "扣减",
      prop: "deduction",
      placeholder: "请输入扣减",
      required: true,
      unit:'元'
    },
    {
      label: "备注",
      prop: "remark",
      placeholder: "请输入备注信息",
      type:'text'
    },
  ],
};

// 支持部门长对话框配置
export const supportDeptDialogConfig = {
  title: "支持部门长绩效",
  readOnlyFields: [
    { label: "一级部门", prop: "dept" },
    { label: "岗位", prop: "position" },
    { label: "职级", prop: "rank" },
    { label: "姓名", prop: "name" },
    { label: "工号", prop: "empno" },
    { label: "渠道", prop: "channel" },
    { label: "月度绩效工资标准", prop: "wagestandard" },
  ],
  editableFields: [
    {
      label: "考核得分",
      prop: "score",
      required: true,
    },
    {
      label: "核算绩效月份数",
      prop: "month",
      required: true,
      unit:'月'

    },

    {
      label: "调节系数",
      prop: "adjust",
      required: true,
    },
    {
      label: "补发",
      prop: "reissue",
      required: true,
      unit:'元'


    },
    {
      label: "扣减",
      prop: "deduction",
      required: true,
      unit:'元'

    },
    {
      label: "备注",
      prop: "remark",
      type:'text'

    },
  ],
};

// 运营提成对话框配置
export const operationDialogConfig = {
  title: "运营提成绩效",
  readOnlyFields: [
    { label: "一级部门", prop: "dept" },
    { label: "岗位", prop: "position" },
    { label: "职级", prop: "rank" },
    { label: "姓名", prop: "name" },
    { label: "工号", prop: "empno" },
    { label: "渠道", prop: "channel" },
    { label: "考核类型", prop: "type" },
    { label: "目标销量", prop: "volume" },
    { label: "岗位提成率（%）", prop: "royaltyrate" },
    { label: "目标毛利率（%）", prop: "ngm" },
  ],
  editableFields: [
    {
      label: "提成月份",
      prop: "month",
      required: true,
      unit:'月'

    },
    {
      label: "实际完成",
      prop: "realfinish",
      required: true,
    },
    {
      label: "KPI得分",
      prop: "kpiscore",
      required: true,
    },
     {
      label: "实际毛利率",
      prop: "realngm",
      required: true,
      unit:'%'

    },
    {
      label: "调节系数",
      prop: "adjust",
      required: true,
    },
    {
      label: "补发",
      prop: "reissue",
      required: true,
      unit:'元'

    },
    {
      label: "扣减",
      prop: "deduction",
      required: true,
      unit:'元'

    },
    {
      label: "备注",
      prop: "remark",
      type:'text'

    },
  ],
};
// 后端绩效对话框配置
export const backendDialogConfig = {
  title: "后端绩效",
  readOnlyFields: [
    { label: "一级部门", prop: "dept" },
    { label: "岗位", prop: "position" },
    { label: "职级", prop: "position" },
    { label: "姓名", prop: "name" },
    { label: "工号", prop: "empno" },
    { label: "渠道", prop: "channel" },
    // 这里取文字版本
    { label: "绩效奖金标准", prop: "kpitype" },
  ],
  editableFields: [
    {
      label: "实际月份数",
      prop: "realmonth",
      required: true,
      unit:'月'

    },
    {
      label: "绩效等级",
      prop: "grade",
      required: true,
      type:'text'
    },

    {
      label: "调节系数",
      prop: "adjust",
      required: true,
    },
    {
      label: "补发",
      prop: "reissue",
      required: true,
      unit:'元'

    },
    {
      label: "扣减",
      prop: "deduction",
      required: true,
      unit:'元'

    },
    {
      label: "备注",
      prop: "remark",
      type:'text'

    },
  ],
};
